import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  FAVOURITES_VIEW,
  ODDS_VIEW,
  FIXTURES_VIEW,
  canSelectMultipleFilters,
  COMBINED_FILTERS_VIEW,
} from "../constants";

export const useFilterType = ({ activeFilterView }) => {
  const { prefetchedFilters } = useSelector((state) => state.filter);
  const isCombinedFiltersView = activeFilterView === COMBINED_FILTERS_VIEW;
  const filterTypeMap = useMemo(() => {
    return new Map([
      [
        FIXTURES_VIEW,
        [
          ...prefetchedFilters.fixtures.today,
          ...prefetchedFilters.fixtures.tomorrow,
        ],
      ],
      [
        ODDS_VIEW,
        [prefetchedFilters.odds.minOdds, prefetchedFilters.odds.maxOdds].filter(
          (odds) => {
            return odds && odds !== 19;
          }
        ),
      ],
      [
        FAVOURITES_VIEW,
        [
          prefetchedFilters.favourites.odds,
          prefetchedFilters.favourites.markets,
        ].filter((favourite) => favourite),
      ],
    ]);
  }, [prefetchedFilters]);

  const filterType = useMemo(
    () =>
      filterTypeMap.get(activeFilterView) ??
      prefetchedFilters[activeFilterView],
    [filterTypeMap, activeFilterView, prefetchedFilters]
  );

  const isMultipleSelection = useMemo(
    () =>
      canSelectMultipleFilters.includes(activeFilterView) ||
      activeFilterView === FAVOURITES_VIEW ||
      activeFilterView === COMBINED_FILTERS_VIEW,
    [activeFilterView]
  );

  const getSelectionCount = () => {
    if (activeFilterView === ODDS_VIEW && filterType.length > 0) {
      return 1;
    }
    return filterType.length;
  };

  const hasValues = useMemo(() => {
    if (typeof filterType === "object" && !Array.isArray(filterType)) {
      return Object.values(filterType).some((value) => value);
    }
    return Array.isArray(filterType) && filterType.length > 0;
  }, [filterType]);

  return {
    filterType,
    isCombinedFiltersView,
    isMultipleSelection,
    getSelectionCount,
    hasValues,
  };
};
